import React, { useState, useEffect } from "react";
import {
  getCurrentDate,
  getFirstDayOfMonth,
  getUniqueUserIds,
} from "@thequantumhub/iam-package";
import { Grid } from "@material-ui/core";
import { Button, Typography } from "@mui/material";

import NarcoticsForm from "./NarcoticsForm";
import NarcoticsDataFilters from "./NarcoticsDataFilters";
import NarcoticsReportSummary from "./NarcoticsReportSummary";
import NarcoticsComplianceTable from "./NarcoticsSummary";

import { getNarcoticsRecords } from "../../../service/endpoint-manager";
import { getUserNames } from "../../../service/endpoint-manager";

import styles from "../../../styles.module.css";

const NarcoticsDashboard = () => {
  const [isDashboard, setIsDashboard] = useState(true);

  const [userNames, setUserNames] = useState([]);

  const [narcoticsRecords, setNarcoticsRecords] = useState([]);
  const [filteredNarcoticsRecords, setFilteredNarcoticsRecords] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);

  const [selectedUser, setSelectedUser] = useState("All");
  const [facilities, setFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState("all");
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("all");
  const [recordStatus, setRecordStatus] = useState("Active");
  const [startDate, setStartDate] = useState(getFirstDayOfMonth());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [timeFilter, setTimeFilter] = useState("quarterly");
  const [columnView, setColumnView] = useState("unit");

  const resetFilters = () => {
    setUnits([]);
    setSelectedUnit("all");
    setRecordStatus("Active");
    setSelectedUser("All");
    setStartDate("");
    setEndDate("");
  };

  const loadData = async () => {
    try {
      const response = await getNarcoticsRecords({
        deleted: recordStatus === "Deleted",
        from: startDate,
        to: endDate,
      });
      let records = response.data.body;

      setNarcoticsRecords(records);
      const userList = getUniqueUserIds(records, "createdBy");
      var result = await getUserNames(userList);
      setUserNames(result.data.body);
      setDataFetched(true);
    } catch (error) {
      console.error("Error fetching narcotics records:", error);
    }
  };

  useEffect(() => {
    setDataFetched(false);
    loadData();
  }, [recordStatus, startDate, endDate]);

  useEffect(() => {
    // filter data according to the applied filters
    const filterData = () => {
      let filteredRecords = narcoticsRecords;

      if (selectedUser !== "All") {
        filteredRecords = filteredRecords.filter(
          (record) => record.createdBy === selectedUser
        );
      }

      if (selectedFacility !== "all") {
        filteredRecords = filteredRecords.filter(
          (record) => record.facility === selectedFacility
        );
      }

      if (selectedUnit !== "all") {
        filteredRecords = filteredRecords.filter(
          (record) => record.unit === selectedUnit
        );
      }

      setFilteredNarcoticsRecords(filteredRecords);
    };

    filterData();
  }, [narcoticsRecords, selectedUser, selectedUnit, selectedFacility]);

  const handleColumnViewChange = (view) => {
    setColumnView(view);
  };

  const handleTimeFilterChange = (newFilter) => {
    setTimeFilter(newFilter);
  };

  return (
    <>
      {isDashboard ? (
        <div>
          <NarcoticsDataFilters
            selectedUser={selectedUser}
            facilities={facilities}
            setFacilities={setFacilities}
            setSelectedUser={setSelectedUser}
            selectedFacility={selectedFacility}
            setSelectedFacility={setSelectedFacility}
            selectedUnit={selectedUnit}
            setSelectedUnit={setSelectedUnit}
            units={units}
            setUnits={setUnits}
            recordStatus={recordStatus}
            setRecordStatus={setRecordStatus}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            resetFilters={resetFilters}
          />
          <NarcoticsComplianceTable
            narcoticsRecords={filteredNarcoticsRecords}
            timeFilter={timeFilter}
            columnView={columnView}
            handleColumnViewChange={handleColumnViewChange}
            handleTimeFilterChange={handleTimeFilterChange}
          />

          <NarcoticsReportSummary
            isDashboard={isDashboard}
            setIsDashboard={setIsDashboard}
            narcoticsRecords={narcoticsRecords}
            setNarcoticsRecords={setNarcoticsRecords}
            filteredNarcoticsRecords={filteredNarcoticsRecords}
            setFilteredNarcoticsRecords={setFilteredNarcoticsRecords}
            userNames={userNames}
            dataFetched={dataFetched}
          />
        </div>
      ) : (
        <>
          <Grid container alignItems="center">
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsDashboard(true);
                }}
              >
                Return to Dashboard
              </Button>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography
                variant="h2"
                style={{ textAlign: "center", margin: "20px 0" }}
              >
                Narcotics Form
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}></Grid>
          </Grid>
          <NarcoticsForm
            isDashboard={isDashboard}
            setIsDashboard={setIsDashboard}
          />
        </>
      )}
    </>
  );
};

export default NarcoticsDashboard;
